import React from 'react'
import { RegistrationFormContainer } from '../RegistrationForm/RegistrationFormContainer'
import style from './RegistrationPage.module.css'

export const RegistrationPage: React.FC = () => {
  return (
    <div className={style.container}>
      <RegistrationFormContainer />
    </div>
  )
}

RegistrationPage.displayName = 'RegistrationPage'
